import React__default from 'react';
import styled from 'styled-components';
import { Button } from '../button/Button.js';
import { Icon } from '../icon/Icon.js';
import { SelectInput } from '../inputs/SelectInput.js';
import { Box } from '../layout/Box.js';
import { getColor } from '../styles/stylePropTypes.js';

const StyledWrapper = styled(Box)`
  & [${Button.dataId}] {
    height: 2rem;
    border-radius: 0.25rem;
    padding: 0rem 2rem 0rem 1rem;
    min-width: 0.75rem;

    [${Icon.dataId}] {
      position: relative;
      left: 0rem;
      font-size: 1rem;
      height: 1.5rem;
      width: 1.25rem;
      top: 0;
    }
  }
  [${Icon.dataId}] {
    position: relative;
    right: 1.5rem;
    top: 0.25rem;
    font-size: 1rem;
    color: ${(props)=>getColor("context", props.theme)};
    pointer-events: none;
    width: 0;
  }
`;
const QuickFilter = ({ icon ="filter-stack" , children , ...props })=>{
    return React__default.createElement(StyledWrapper, null, React__default.createElement(SelectInput, {
        "data-hpy-web-quickfilter": true,
        ...props,
        variant: "context-secondary",
        icon: icon,
        showSelectedLabel: true,
        as: "button",
        width: "content"
    }, children), React__default.createElement(Icon, {
        icon: "caret-down"
    }));
};
QuickFilter.dataId = "data-hpy-web-quickfilter";
QuickFilter.displayName = "QuickFilter";

export { QuickFilter };
